import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import * as ko from 'knockout';

@Component({
    selector: 'dk-currency-calculator',
    inputs: ['walletDepositMode'],
    template: require('./currency-calculator.html')
})

export class CurrencyCalculatorComponent implements OnInit, OnDestroy {
    public walletDepositMode: boolean = false;
    public calculatorParams: any;

    constructor(private element: ElementRef) {
    }

    ngOnInit() {
        ko.applyBindings({}, this.element.nativeElement);
    }

    ngOnDestroy() {
        ko.removeNode(this.element.nativeElement);
    }
}
